function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_7612_56603)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M10 5.5C10.925 5.5 11.6667 4.75 11.6667 3.83333C11.6667 3.51667 11.5833 3.225 11.425 2.975L10 0.5L8.575 2.975C8.41667 3.225 8.33333 3.51667 8.33333 3.83333C8.33333 4.75 9.08333 5.5 10 5.5ZM15 8H10.8333V6.33333H9.16667V8H5C3.61667 8 2.5 9.11667 2.5 10.5V18C2.5 18.4583 2.875 18.8333 3.33333 18.8333H16.6667C17.125 18.8333 17.5 18.4583 17.5 18V10.5C17.5 9.11667 16.3833 8 15 8ZM15.8333 17.1667H4.16667V14.6667C4.91667 14.6583 5.63333 14.3583 6.16667 13.825L7.075 12.9333L7.96667 13.825C9.05833 14.9167 10.9583 14.9083 12.0417 13.825L12.9417 12.9333L13.8333 13.825C14.3667 14.3583 15.0833 14.6583 15.8333 14.6667V17.1667ZM15.8333 13.4167C15.4083 13.4083 15.0083 13.25 14.7083 12.9417L12.9333 11.1667L11.15 12.9417C10.5333 13.5583 9.45833 13.5583 8.84167 12.9417L7.06667 11.1667L5.28333 12.9417C4.99167 13.2417 4.59167 13.4083 4.16667 13.4167V10.5C4.16667 10.0417 4.54167 9.66667 5 9.66667H15C15.4583 9.66667 15.8333 10.0417 15.8333 10.5V13.4167Z",
  fill: "#323232"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_7612_56603"
}, /*#__PURE__*/React.createElement("rect", {
  width: 20,
  height: 20,
  fill: "white",
  transform: "translate(0 0.5)"
})));

function SvgDob(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDob);
export default __webpack_public_path__ + "static/media/dob.50f858b9.svg";
export { ForwardRef as ReactComponent };